import { render } from "./crashRoom.vue?vue&type=template&id=74ce9cdd&scoped=true"
import script from "./crashRoom.vue?vue&type=script&lang=js"
export * from "./crashRoom.vue?vue&type=script&lang=js"

import "./crashRoom.vue?vue&type=style&index=0&id=74ce9cdd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ce9cdd"]])

export default __exports__